<template>
	<v-card v-if="edit && !isFetching">
		<v-card-title primary-title>
			<EditTextTask 
			:showButtons="true"
			validate-method="checkpointsValidator/validateTextTaskEdit"
			v-if="taskType == 0"

			></EditTextTask>
			<EditImageTask v-if="taskType == 6 || taskType == 20"
			validate-method="checkpointsValidator/validateImageTaskEdit"
			></EditImageTask>
			<EditImageTask v-if="taskType == 15"
			validate-method="checkpointsValidator/validateCameraTaskEdit"
			></EditImageTask>
			<EditSingleImageTask v-if="taskType == 21"
			validate-method="checkpointsValidator/validateSingleImageTask"
			></EditSingleImageTask>
			<EditAudioTask 
			v-if="taskType == 4"
			validate-method="checkpointsValidator/validateAudioTaskEdit"
			></EditAudioTask>
			<EditVideoTask v-if="taskType == 7 
				|| taskType == 17
				|| taskType == 12
				"
				></EditVideoTask>
			<EditYoutubeVideoTask v-if="taskType == 19"></EditYoutubeVideoTask>
			<EditSlidesTask v-if="taskType == 13"></EditSlidesTask>
			<EditSeasonVideoTask v-if="taskType == 14"></EditSeasonVideoTask>
			<!--EditCameraTask v-if="taskType == 15"></EditCameraTask-->
			<EditTextTask 
			:showButtons="true"
			validate-method="checkpointsValidator/validateFeedbackTaskEdit"
			v-if="taskType == 18"></EditTextTask>


			
		</v-card-title>
	</v-card>
</template>

<script>
	
	import EditTextTask from './EditTextTask';
	import EditImageTask from './EditImageTask';
	import EditSingleImageTask from './EditSingleImageTask';
	import EditAudioTask from './EditAudioTask';
	import EditVideoTask from './EditVideoTask';
	import EditYoutubeVideoTask from './EditYoutubeVideoTask';
	import EditSlidesTask from './EditSlidesTask';
	import EditSeasonVideoTask from './EditSeasonVideoTask';
	import EditCameraTask from './EditCameraTask';

	export default {
		name: 'EditTask',
		components: {
			EditTextTask,
			EditImageTask,
			EditAudioTask,
			EditVideoTask,
			EditYoutubeVideoTask,
			EditSlidesTask,
			EditSeasonVideoTask,
			EditCameraTask,
			EditSingleImageTask},
		computed: {
			edit:{
				get()
				{
					return this.$store.getters['checkpoints/editTask'];
				},
				set(value)
				{
					this.$store.dispatch('checkpoints/setEditTask', value)
				}

			},

			taskType: {
				get()
				{
					
					let t = this.$store.getters['checkpoints/editableTask'].type
					
					return t;
				},

				
			},

			isFetching:{
				get()
				{
					return this.$store.getters['checkpoints/isFetching'];
				}
			}
		},

		created()
		{
			//console.log("EditTask Created")
		}
	}
</script>